/**
 * What a search box may send to the server.
 *
 * <p>A MIRROR of the server's rule, checked before anything is sent: letters in any
 * script, digits, space, and the four characters that turn up in names and regos —
 * . ' & - — up to a hundred of them. The server answers 400 with the same sentence
 * for anything else; checking here means the sentence appears under the box as it is
 * typed, and a keystroke never costs a round trip that will be refused.
 *
 * <p>The server stays the authority. If its answer ever differs, its message is shown
 * verbatim — see the slices, which keep the server's own sentence.
 */

export const SEARCH_TERM_MAX = 100;

/** The one message, the same words the server uses. */
export const SEARCH_TERM_MESSAGE = "Letters, numbers, spaces and .'&- only";

// \p{L} is any letter in any script, \p{N} any digit. The `u` flag makes those work.
const ALLOWED = /^[\p{L}\p{N} .'&-]*$/u;

/**
 * @param {string} text what was typed, untrimmed
 * @returns {{ ok: boolean, message: string|null }} ok with no message, or not ok with
 *          the sentence to show under the box
 */
export function validateSearchTerm(text) {
    const value = text ?? '';
    if (value.length > SEARCH_TERM_MAX || !ALLOWED.test(value)) {
        return { ok: false, message: SEARCH_TERM_MESSAGE };
    }
    return { ok: true, message: null };
}

/**
 * The term to put on the wire, or null for nothing: blank, or something the server
 * would refuse. Trimmed, because a bare `?q= ` is a filter the server would apply.
 */
export function serverSearchTerm(text) {
    if (!validateSearchTerm(text).ok) return null;
    const trimmed = (text ?? '').trim();
    return trimmed ? trimmed : null;
}
